import ViewsApproval from "@/views/approval/ViewsApproval";
import ViewsDelegate from "@/views/approval/ViewsDelegate";

import {PERMISSIONS} from "@/constants";
import {home} from "@/router/breadcrumbs";

export default {
    routes: [{
        path: "/approvals",
        name: "approvals",
        component: ViewsApproval,
        meta: {
            requireAuth: true,
            breadcrumbs: [home, {
                text: "approvals"
            }],
            permissions: [PERMISSIONS.MANAGER]
        }
    }, {
        path: "/approvals/delegate",
        name: "approvals.delegate",
        component: ViewsDelegate,
        meta: {
            requireAuth: true,
            breadcrumbs: [home, {
                text: "delegate"
            }],
            permissions: [PERMISSIONS.MANAGER]
        }
    }]
}